import script from "./PdContactCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PdContactCard.vue?vue&type=script&setup=true&lang=js"

import "./PdContactCard.vue?vue&type=style&index=0&id=662f9dbe&scoped=true&lang=css"

import exportComponent from "../../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-662f9dbe"]])

export default __exports__